<template>
  <div id="app" @touchstart="touchStart($event)" @touchmove="touchMove($event)">
    <navHeader :moveUp="moveUp"></navHeader>
    <keep-alive>
      <router-view />
    </keep-alive>
    <navFooter v-if="flag"></navFooter>
  </div>
</template>
<script>
import navHeader from "@/components/nav-header.vue";
import navFooter from "@/components/nav-footer.vue";
export default {
  components: {
    navHeader,
    navFooter,
  },
  data() {
    return {
      flag: true,
      clientWidth: 0,
      isMobile: false,
      moveUp: true,
      dis: 0,
    };
  },
  created() {
    if (this.$route.name === "enquiry-mobile") {
      this.flag = false;
    } else {
      this.flag = true;
    }
  },
  updated() {
    if (this.$route.name === "enquiry-mobile") {
      this.flag = false;
    } else {
      this.flag = true;
    }
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? "Mobile"
        : "Desktop";
    this.isMobile = detectDeviceType() === "Mobile";
    if (!this.isMobile) {
    }
    this.clientWidth = this.$el.clientWidth;
    this.changeFont();
    var that = this;
    window.onresize = () => {
      return (() => {
        this.clientWidth = this.$el.clientWidth;
        that.changeFont();
      })();
    };
  },
  methods: {
    touchStart(e) {
      this.msg = "start";
      this.dis = e.touches[0].screenY;
    },
    touchMove(e) {
      let disY = e.touches[0].screenY - this.dis;
      if (disY > 0) {
        // console.log('下滑')
        this.moveUp = true;
      } else {
        // console.log('上滑')
        this.moveUp = false;
      }
    },
    changeFont() {
      if (this.isMobile) {
        let fontsize = (100 / 375) * this.clientWidth;
        document.getElementsByTagName("html")[0].style.fontSize =
          fontsize + "px";
      } else {
        let fontsize = (100 / 1920) * this.clientWidth;
        document.getElementsByTagName("html")[0].style.fontSize =
          fontsize + "px";
      }
    },
  },
};
</script>
<style lang="less">
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
}

#app {
  font-family: "Poppins-Regular", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.g-tac {
  text-align: center !important;
}
.g-fwb {
  font-weight: bold !important;
}
.g-tal {
  text-align: left !important;
}
</style>
